
<div id="create_borrower_account" class="collapse show">
  <borrower-info customMessage="For the Co-borrower, what is their:" [borrower]="borrower"></borrower-info>
  <div class="row">
    <wizard-button-group></wizard-button-group>
  </div>
</div>

